import { render, staticRenderFns } from "./GraficoLaboral.vue?vue&type=template&id=563909b0&"
import script from "./GraficoLaboral.vue?vue&type=script&lang=js&"
export * from "./GraficoLaboral.vue?vue&type=script&lang=js&"
import style0 from "./GraficoLaboral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports